import { ButtonGroup, Card } from "@blueprintjs/core"
import CustomButton from "components/Atoms/CustomButton"
import Divider from "components/Atoms/Divider"
import Paper from "components/Atoms/Paper"
import QueryBar from "components/Common/QueryBar"
import { useCreateUpdateRouteAssignmentMutation } from "generated/graphql"
import { ROUTE_ASSIGNMENT_DETAIL } from "graphql/routes/routes.queries.gql"
import useRouteStore from "pages/fsm/routes.store"
import React from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import AppToaster from "utils/AppToaster"
import BeatListView from "./BeatListView"
import BeatMapView from "./BeatMapView"

type AddVendorViewType = {
  disabled?: boolean
}
const AddVendorView = ({ disabled }: AddVendorViewType) => {
  const store = useRouteStore()
  const data = store.data
  const navigate = useNavigate()
  const [params, setParams] = useSearchParams()
  const search = params.get("search")
  const view = params.get("view")
  const allOutlets = useRouteStore(store => store.allOutlets(search, true))
  const isMap = view === "map"

  function handleParamChange(value: string) {
    return () => {
      setParams({ view: value })
    }
  }
  const [update, { loading }] = useCreateUpdateRouteAssignmentMutation({
    onError({ message }) {
      AppToaster.show({ message, intent: "danger" })
    },
    onCompleted() {
      AppToaster.show({
        message: `Outlets assigned successfully!`,
        intent: "success",
        icon: "tick",
      })
      store.reset()
      navigate("/d/fsm/beat")
    },
    refetchQueries: [
      {
        query: ROUTE_ASSIGNMENT_DETAIL,
        variables: {
          id: store.data.id,
        },
      },
    ],
  })
  return (
    <Card className="bg-white shadow-none text-sm rounded-lg mt-3 p-0">
      <header className="py-2 px-3 grid grid-cols-6 items-center">
        <div className="flex items-center">
          <span className="mr-3">Customers</span>
          <ButtonGroup id="map-list-toggle">
            <CustomButton
              onClick={handleParamChange("map")}
              intent={isMap ? "success" : "none"}
              icon="map"
            >
              Map
            </CustomButton>
            <CustomButton
              onClick={handleParamChange("list")}
              intent={!isMap ? "success" : "none"}
              icon="list"
            >
              List
            </CustomButton>
          </ButtonGroup>
        </div>
        {view === "map" ? (
          <div className="col-span-4 w-full" />
        ) : (
          <QueryBar
            className="col-span-4 w-full flex justify-center items-center"
            value={search}
            onChange={query => {
              params.set("search", query)
              setParams(params)
            }}
            round={false}
          />
        )}
        <div className="flex justify-end">
          <CustomButton
            id="fsm-publish-beat"
            disabled={disabled}
            loading={loading}
            onClick={() => {
              // Update Assignment
              update({
                variables: {
                  id: data.id,
                  points: data.selectedOutlets.map((outlet, index) => ({
                    sequence: (index + 1).toString(),
                    visiteeId: outlet.id,
                  })),
                },
              })
            }}
            intent="success"
          >
            Publish
          </CustomButton>
        </div>
      </header>

      {isMap ? (
        <>
          <Divider className="my-0" />
          <BeatMapView disabled={disabled} />
        </>
      ) : (
        <Paper>
          <BeatListView data={allOutlets} disabled={disabled} />
        </Paper>
      )}
    </Card>
  )
}

export default AddVendorView
